import { render, staticRenderFns } from "./SignupRoot.vue?vue&type=template&id=d08d0bc4&"
import script from "./SignupRoot.vue?vue&type=script&lang=js&"
export * from "./SignupRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports